# Create the SpOrdersLocation4CreateEdit.vue modal component
<template>
    <b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
        <CRow>
            <CCol>
                <b-card>
                    <CRow>
                        <CCol sm="4">
                            <CInput
                                label="Koda znamke"
                                :disabled="editingDisabled"
                                @input="setItemEditing"
                                v-model="item.brand_code"/>
                        </CCol>
                        <CCol sm="4">
                            <CInput
                                label="Številka ND"
                                :disabled="editingDisabled"
                                @input="setItemEditing"
                                v-model="item.part_number"/>
                        </CCol>
                        <CCol sm="4">
                            <CInput
                                label="Opis"
                                :disabled="editingDisabled"
                                @input="setItemEditing"
                                v-model="item.description"/>
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="4">
                            <CInput
                                label="Lokacija"
                                :disabled="editingDisabled"
                                @input="setItemEditing"
                                v-model="item.main_location"/>
                        </CCol>
                        <CCol sm="4">
                            <CInput
                                label="Skupina delov"
                                :disabled="editingDisabled"
                                @input="setItemEditing"
                                v-model="item.parts_group"/>
                        </CCol>
                        <CCol sm="4">
                            <CInput
                                label="Zaloga"
                                type="number"
                                :disabled="editingDisabled"
                                @input="setItemEditing"
                                v-model.number="item.stock_quantity"/>
                        </CCol>
                    </CRow>
                    <CRow class="mt-3">
                        <CCol sm="4">
                            <CInput
                                label="Nabavna cena"
                                type="number"
                                step="0.01"
                                :disabled="editingDisabled"
                                @input="setItemEditing"
                                v-model.number="item.purchase_price"/>
                        </CCol>
                        <CCol sm="4">
                            <CInput
                                label="Cena po ceniku"
                                type="number"
                                step="0.01"
                                :disabled="editingDisabled"
                                @input="setItemEditing"
                                v-model.number="item.list_price"/>
                        </CCol>
                        <CCol sm="4">
                            <CInput v-if="editingDisabled"
                                :disabled = editingDisabled
                                label="Datum sprejema"
                                :value="item.date_of_last_admission | viewDate"/>
                            <v-date-picker v-else
                                locale="sl-SI"
                                @input="setSpOrderEditing"
                                v-model="item.date_of_last_admission"
                                :model-config=" {
                                    type: 'string',
                                }"
                                timezone='utc'>
                                <template v-slot="{ inputValue, inputEvents }">
                                    <CInput
                                        label="Datum sprejema"
                                        :value="inputValue"
                                        v-on="inputEvents"/>
                                </template>
                            </v-date-picker>
                        </CCol>
                    </CRow>
                </b-card>
            </CCol>
        </CRow>
        <CAlert v-show="message.text != null" :color="message.type">
            {{ message.text }}
        </CAlert>
        <template slot="modal-footer" slot-scope="{ cancel }">
            <b-container fluid class="p-0">
                <b-row>
                    <b-col align-self="end" class="ma_pos">
                        <b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
                        <b-button :disabled="okButton.disabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </template>
        <vue-loading :active.sync="isLoading" :is-full-page="false"/>
    </b-modal>
</template>

<script>
import { SP_ORDERS_LOCATION4_CREATE } from "@/store/actions/spOrdersLocation4";
import PermissionCheck from '@/tools/permission-check';

export default {
    name: 'sp-orders-location4-create-edit-modal',
    components: {
    },
    methods: {
        showModal: function (modalInput) {
            /*
                mode 1 => Create
                mode 2 => Edit
            */
            this.mode = modalInput.mode;
            this.initModal(modalInput.item);
        },
        initModal: function (item) {
            if (this.mode === this.mode_CREATE1) {
                this.title = 'Dodajanje lokacije 4';
                this.okButton.label = 'Dodaj';
            } else if (this.mode === this.mode_EDIT2) {
                this.title = 'Urejanje lokacije 4';
                this.initItem(item);
                this.okButton.label = 'Shrani';
            } else {
                this.mode = this.mode_UNKNOWN0;
                this.title = 'Neznan način';
                this.okButton.label = 'Zapri';
            }
            this.$refs.modal.show();
        },
        initItem: function (item) {
            this.item.id = item.id;
            this.item.brand_code = item.brand_code;
            this.item.part_number = item.part_number;
            this.item.description = item.description;
            this.item.main_location = item.main_location;
            this.item.parts_group = item.parts_group;
            this.item.stock_quantity = item.stock_quantity;
            this.item.purchase_price = item.purchase_price;
            this.item.list_price = item.list_price;
            this.item.date_of_last_admission = item.date_of_last_admission;
        },
        onOkModal: function () {
            if (!this.validateForm()) {
                return;
            }
            this.startProgress();
            this.$store.dispatch(SP_ORDERS_LOCATION4_CREATE, { item: this.item })
                .then((responseData) => {
                    this.stopProgress();
                    this.$refs.modal.hide();
                    this.$emit('emit_spOrdersLocation4Change', responseData);
                })
                .catch(error => {
                    this.stopProgress();
                    console.error(error);
                    if(error.response && error.response.data && error.response.data.code) {
                        if (this.mode === this.mode_CREATE1) {
                            this.showAlert('Napaka pri dodajanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
                        } else if (this.mode === this.mode_EDIT2) {
                            this.showAlert('Napaka pri urejanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
                        } else {
                            this.showAlert('Neznan način modala! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
                        }
                    } else {
                        this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
                    }
                });
        },
        validateForm: function() {
            if (!this.item.brand_code) {
                this.showAlert('Koda znamke je obvezna!', this.ALERT_TYPE_ERROR);
                return false;
            }
            if (!this.item.part_number) {
                this.showAlert('Številka ND je obvezna!', this.ALERT_TYPE_ERROR);
                return false;
            }
            if (!this.item.description) {
                this.showAlert('Opis je obvezen!', this.ALERT_TYPE_ERROR);
                return false;
            }
            return true;
        },
        clearModalData: function () {
            this.isLoading = false;
            this.title = '';
            this.okButton = {
                label: 'Shrani',
                progress: false,
                disabled: false
            };
            this.showAlert();
            this.mode = 0;
            this.resetItemObject();
        },
        resetItemObject: function () {
            this.item.id = null;
            this.item.brand_code = null;
            this.item.part_number = null;
            this.item.description = null;
            this.item.main_location = null;
            this.item.parts_group = null;
            this.item.stock_quantity = null;
            this.item.purchase_price = null;
            this.item.list_price = null;
            this.item.date_of_last_admission = null;
        },
        startProgress: function () {
            this.isLoading = true;
            this.okButton.disabled = true;
            this.okButton.progress = true;
        },
        stopProgress: function () {
            this.isLoading = false;
            this.okButton.disabled = false;
            this.okButton.progress = false;
        },
        showAlert: function (message, type, seconds) {
            if (message && type && seconds) {
                this.message.type = type;
                this.message.text = message;
                setTimeout(() => {
                    this.showAlert();
                }, seconds * 1000);
            } else if (message && type) {
                this.message.type = type;
                this.message.text = message;
            } else if (message) {
                this.message.type = 'primary';
                this.message.text = message;
            } else {
                this.message.type = null;
                this.message.text = null;
            }
        },
        setItemEditing: function() {
            this.isItemEditing = true;
        }
    },
    data: function () {
        return {
            isLoading: false,
            title: '',
            okButton: {
                label: 'Shrani',
                progress: false,
                disabled: false
            },
            message: {
                type: null,
                text: null
            },
            ALERT_TYPE_SUCCESS: 'success',
            ALERT_TYPE_ERROR: 'danger',
            mode_UNKNOWN0: 0,
            mode_CREATE1: 1,
            mode_EDIT2: 2,
            mode: 0,
            item: {
                id: null,
                brand_code: null,
                part_number: null,
                description: null,
                main_location: null,
                parts_group: null,
                stock_quantity: null,
                purchase_price: null,
                list_price: null,
                date_of_last_admission: null,
            },
            isItemEditing: false,
            permissionCheck: PermissionCheck
        }
    },
    computed: {
        modalSize () {
            return 'lg';
        },
        editingDisabled () {
            return false;
        }
    }
}
</script>

<style scoped>
.ma_pos {
    text-align: end;
}
</style> 